//Video Section
import SearchProperty from 'assets/images/psp/search-property.svg';

//Unit Size Description
import smallUnit from 'assets/images/unit-icons/new/5x5.svg';
import mediumUnit from 'assets/images/unit-icons/new/10x10.svg';
import largeUnit from 'assets/images/unit-icons/new/10x25.svg';
import fiveByTenUnit from 'assets/images/unit-icons/new/5x10.svg';
import fiveByFifteenUnit from 'assets/images/unit-icons/new/5x15.svg';
import tenByFifteenUnit from 'assets/images/unit-icons/new/10x15.svg';
import tenByTwentyUnit from 'assets/images/unit-icons/new/10x20.svg';
import tenByThirtyUnit from 'assets/images/unit-icons/new/10x30.svg';
import storageLocker from 'assets/images/unit-icons/new/locker.svg';

//Oversized Items
import Bed from 'assets/images/icons/size-guide/bed.svg';
import Bike from 'assets/images/icons/size-guide/bike.svg';
import Couch from 'assets/images/icons/size-guide/couch.svg';
import Fridge from 'assets/images/icons/size-guide/fridge.svg';
import Kayak from 'assets/images/icons/size-guide/kayak.svg';
import Mower from 'assets/images/icons/size-guide/mower.svg';
import Table from 'assets/images/icons/size-guide/table-2.svg';
import TV from 'assets/images/icons/size-guide/tv.svg';
import Washer from 'assets/images/icons/size-guide/washer.svg';

import overSized from 'assets/images/psp/oversized.svg';
import findStorageNearYouPin from 'assets/images/icons/find-storage-near-you.svg';

//Hero Section
import faqIcon from 'assets/images/psp/faq.svg';
import VehicleStorage from 'assets/images/icons/size-guide/vehicle-storage.svg';
import arrow from 'assets/images/icons/size-guide/arrow.svg';
import vehicle10x15 from 'assets/images/icons/size-guide/vehicle-10x15.svg';
import vehicle10x20 from 'assets/images/icons/size-guide/vehicle-10x20.svg';
import vehicle10x25 from 'assets/images/icons/size-guide/vehicle-10x25.svg';
import vehicle10x30 from 'assets/images/icons/size-guide/vehicle-10x30.svg';
import vehicle10x40 from 'assets/images/icons/size-guide/vehicle-10x40.svg';
import vehicle10x50 from 'assets/images/icons/size-guide/vehicle-10x50.svg';
import vehicle10x35 from 'assets/images/icons/size-guide/vehicle-10x35.svg';

import measuringTapeRulerIcon from 'assets/images/icons/size-guide/measuring-tape-ruler.svg';

import boatIcon from 'assets/images/icons/size-guide/boat-icon.svg';


export const sizeGuideContent = {
	title: 'Ultimate Storage Unit Size Guide',
	pageType: 'SGP',
	isSizeGuideHomePage: true,
	sections: [
		{
			title: 'Storage Calculator',
			background: 'gradient',
			modules: [
				{
					type: 'commonSectionHeader',
					props: {
						title: 'Ultimate Storage Unit Size Guide',
						description:
							'Choosing the right storage unit size can feel overwhelming, but our storage unit size calculator makes it easy. To find the right storage unit for you, simply select the types and amounts of items you want to store and our calculator will quickly suggest the best unit size for your needs.',
						image: measuringTapeRulerIcon,
						className: 'sf-unit-size-guide-header',
						additionalProps: {
							isSizeGuideHeader: true,
						},
					},
				},
				{
					type: 'SecondaryNav',
				},
				{
					type: 'storageCalculatorEmbedSGP',
					props: {
						title: 'Storage Unit Size Calculator',
						type: 'facility',
						slug: 'size-guide-storage-calculator-embed',
					},
				},
			],
		},
		{
			title: 'New Video Section',
			modules: [
				{
					type: 'newVideoSection',
					props: {
						slug: 'How to Pick the Right Storage Unit Size Video',
						src: 'https://www.youtube.com/embed/vurAgsMDdf0?rel=0&playsinline=1&enablejsapi=1',
						content: {
							title: 'Choose Between Different Storage Unit Size Options',
							description:
								"Most people need help picking the right storage unit size. Whether you're looking to store the contents of an entire four-bedroom home or just your seasonal clothing, there's a storage unit size that's right for you. The size guide below compares the most standard storage unit sizes for small, medium, or large units.",
						},
						className: 'sf-size-guide-video-section',
						image: SearchProperty,
					},
				},
			],
		},
		{
			title: 'Small Storage Unit Sizes',
			modules: [
				{
					type: 'markdownSection',
					props: {
						slug: 'small storage size guide',
						id: 'small storage size guide',
						additionalProps: {
							heading: {
								family: 'rounded',
							},
						},
						content:
							'## Small Storage Units \n Choose from a 5x5, 5x10, or 5x15 unit, which are the ideal storage unit sizes for seasonal decor, sporting equipment, business inventory, or small household items. Small storage units range in size from 25 to 75 square feet, which is the equivalent of a hall closet, half bathroom, or compact bedroom.',
					},
				},
				{
					type: 'unitCards',
					id: 'storage size unit cards',
					props: {
						pageType: 'SGP',
						slug: 'storage-size-guide-unit-cards',
						scrollable: false,
						unitCards: [
							{
								layout: false,
								title: 'Storage Lockers',
								infoTag: '0 to 15 SQ FT',
								image: storageLocker,
								content:
									'#### How big is a storage locker? \n Storage lockers range from 0 to 15 square feet. They are much smaller than a traditional storage unit and are typically stacked on top of one another. The ceiling height in a storage locker ranges from two to five feet. \n #### What will fit in a storage locker? \n A storage locker is ideal if you only need to store a few boxes, bags, or small miscellaneous items.',
							},
							{
								layout: false,
								title: '5’ x 5’ Unit',
								infoTag: '25 SQ FT',
								image: smallUnit,
								content:
									"#### How big is a 5x5 storage unit? \n A 5x5 storage unit is 25 square feet and the size of a hall closet or half bathroom. \n #### What fits in a 5x5 storage unit? \n A 5x5 storage unit will fit a dresser, a small mattress set, and several boxes. Other uses include holiday decorations, gardening equipment, camping gear, children's toys, and off-season clothing. A 5x5 unit is perfect for about 15-20 regular-size boxes.",
							},
							{
								layout: false,
								title: '5’ x 10’ Unit',
								infoTag: '50 SQ FT',
								image: fiveByTenUnit,
								content:
									'#### How big is a 5x10 storage unit? \n A 5x10 storage unit is 50 square feet and about the size of a large walk-in closet. \n #### What fits in a 5x10 storage unit? \n A 5x10 storage unit will easily fit furniture from a studio or one-bedroom apartment, including a queen-size mattress set, a love seat, a dresser, a TV, a bike, and several storage boxes. It can also easily fit about 30 or more regular-size boxes.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Medium Storage Unit Sizes',
			modules: [
				{
					type: 'markdownSection',
					props: {
						slug: 'medium storage size guide',
						id: 'medium storage size guide',
						additionalProps: {
							heading: {
								family: 'rounded',
							},
						},
						content:
							'## Medium Storage Units \n Medium storage units range in size from 10x10, 10x15, or 10x20, which are the ideal storage unit sizes for a one-bedroom apartment up to a two-to-three-bedroom house, depending on how much furniture and large appliances you need to store. Medium-sized units range from 75 to 200 square feet, equivalent to an average bedroom, up to a one-car garage.',
					},
				},
				{
					type: 'unitCards',
					id: 'storage size unit cards',
					props: {
						slug: 'storage-size-guide-unit-cards',
						scrollable: false,
						unitCards: [
							{
								layout: false,
								title: '5’ x 15’ Unit',
								infoTag: '75 SQ FT',
								image: fiveByFifteenUnit,
								content:
									'#### How big is a 5x15 unit? \n A 5x15 storage unit is 75 square feet and similar in size to a small bedroom. \n #### What fits in a 5x15 storage unit? \n Furniture from a small one-bedroom apartment, including a queen-size mattress set, love seat, dresser, TV, bike, and several boxes, will fit in a 5x15 unit. A 5x15 unit can hold anywhere from 30 to 35 regular-size boxes.',
							},
							{
								layout: false,
								title: '10’ x 10’ Unit',
								infoTag: '100 SQ FT',
								image: mediumUnit,
								content:
									'#### How big is a 10x10 storage unit? \n A 10x10 storage unit is 100 square feet and about the size of an average bedroom. \n #### What fits in a 10x10 storage unit? \n Furniture items from two bedrooms and an entire family room can fit in a 10x10 storage unit. This may include mattress sets, dressers, nightstands, sofa, chairs, coffee table, book shelves and more. If you were storing nothing but medium-sized boxes that are 20 inches by 20 inches, you could expect a 10x10 storage unit to hold up to 100 boxes. By the time you add furniture pieces and bedroom sets, the number of boxes a unit could hold is more like 50-60.',
							},
							{
								layout: false,
								title: '10’ x 15’ Unit',
								infoTag: '150 SQ FT',
								image: tenByFifteenUnit,
								content:
									'#### How big is a 10x15 storage unit? \n A 10x15 storage unit is 150 square feet, equivalent in size to a small one-car garage. \n #### What fits in a 10x15 storage unit? \n A 10x15 storage unit will hold the contents of a two—or three-bedroom house, including oversized items like big-screen TVs, couches, entertainment centers, office furniture, dining tables and chairs, and large kitchen appliances like a refrigerator. A minimum of 60 standard-size boxes should fit within a 10x15 unit.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Large Storage Unit Sizes',
			modules: [
				{
					type: 'markdownSection',
					props: {
						slug: 'storage size guide',
						id: 'storage size guide',
						additionalProps: {
							heading: {
								family: 'rounded',
							},
						},
						content:
							'## Large Storage Units \n The most common large unit sizes are 10x20, 10x25, or 10x30, ideal storage unit sizes for a three-bedroom or four-to-five-bedroom house with large appliances, like a washer and dryer and refrigerator. Large units are typically the equivalent of a one-car or two-car garage.',
					},
				},
				{
					type: 'unitCards',
					id: 'storage size unit cards',
					props: {
						slug: 'storage-size-guide-unit-cards',
						scrollable: false,
						unitCards: [
							{
								layout: false,
								title: "10' x 20' Unit",
								infoTag: '200 SQ FT',
								image: tenByTwentyUnit,
								content:
									'#### How big is a 10x20 storage unit? \n A 10x20 storage unit is 200 square feet and the size of a standard one-car garage. \n ### What fits in a 10x20 storage unit? \n Items from a three—or four-bedroom house or apartment will fit in a 10x20 unit. These may include couches, mattress sets (queen-size and king-size sets), a dining room set, workout equipment, a refrigerator, and a washer and dryer. A 10x20 storage unit should easily store 80-100 boxes.',
							},
							{
								layout: false,
								title: '10’ x 25’ Unit',
								infoTag: '250 SQ FT',
								image: largeUnit,
								content:
									'#### How big is a 10x25 storage unit? \n A 10x25 storage unit is 250 square feet and slightly larger than a standard one-car garage. \n ### What fits in a 10x25 storage unit? \n A 10x25 storage unit fits the contents of a large four-bedroom house. It can fit several bedroom sets, living room and game room furniture, gym equipment, large appliances, dining room furniture, office furniture, and a minimum of 100 boxes.',
							},
							{
								layout: false,
								title: '10’ x 30’ Unit',
								infoTag: '300 SQ FT',
								image: tenByThirtyUnit,
								content:
									'#### How big is a 10x30 storage unit? \n A 10x30 storage unit is 300 square feet and the size of a standard two-car garage. \n ### What fits in a 10x30 storage unit? \n A 10x30 storage unit will hold items from a fully furnished five-bedroom house, including mattress sets, dressers, couches, a dining room set, an entertainment center, major appliances, seasonal items, outdoor equipment, and bikes. The 10x30 unit is typically one of the largest sizes available and can hold over 100 boxes, as people have a combination of boxes, personal items, and furniture that need safekeeping.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Storage Unit Size Chart',
			modules: [
				// {
				// 	type: 'markdownSection',
				// 	props: {
				// 		slug: 'Storage Unit Size Chart',
				// 		id: 'Storage Unit Size Chart',
				// 		additionalProps: {
				// 			heading: {
				// 				family: 'rounded',
				// 			},
				// 		},
				// 		content:
				// 			'## Storage Unit Size Chart \n Use the storage unit sizes chart below to find the right size for your needs or personal property.',
				// 	},
				// },
				{
					type: 'sizeChart',
					props: {
						title: 'Storage Unit Size Chart',
						description:
							'Use the storage unit sizes chart below to find the right size for your needs or personal property.',
						slug: 'sgp-size-chart-section',
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Square Feet',
								key: 'Square Feet',
							},
							{
								label: 'Cubic Feet',
								key: 'Cubic Feet',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'icon',
									icon: storageLocker,
									heading: 'Storage Locker',
								},
								'Square Feet': '0-15 ft²',
								'Cubic Feet': '0-120 ft³',
								'Best For': {
									type: 'checklist',
									list: ['Miscellaneous Items'],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: smallUnit,
									heading: '5x5',
								},
								'Square Feet': '25 ft²',
								'Cubic Feet': '200 ft³',
								'Best For': {
									type: 'checklist',
									list: ['Miscellaneous Items'],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: fiveByTenUnit,
									heading: '5x10',
								},
								'Square Feet': '50 ft²',
								'Cubic Feet': '400 ft³',
								'Best For': {
									type: 'checklist',
									list: [
										'Studio Apartment',
										'1-Bedroom Apartment',
										'Motorcycle',
									],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: fiveByTenUnit,
									heading: '5x15',
								},
								'Square Feet': '75 ft²',
								'Cubic Feet': '600 ft³',
								'Best For': {
									type: 'checklist',
									list: [
										'Studio Apartment',
										'1-Bedroom Apartment',
									],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: mediumUnit,
									heading: '10x10',
								},
								'Square Feet': '100 ft²',
								'Cubic Feet': '800 ft³',
								'Best For': {
									type: 'checklist',
									list: [
										'2-Bedroom Apartment',
										'2-Bedroom House',
									],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByFifteenUnit,
									heading: '10x15',
								},
								'Square Feet': '150 ft²',
								'Cubic Feet': '1,200 ft³',
								'Best For': {
									type: 'checklist',
									list: [
										'2-Bedroom Apartment',
										'2-Bedroom House',
									],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByTwentyUnit,
									heading: '10x20',
								},
								'Square Feet': '200 ft²',
								'Cubic Feet': '1,600 ft³',
								'Best For': {
									type: 'checklist',
									list: ['2-Bedroom House', 'Car'],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByFifteenUnit,
									heading: '10x25',
								},
								'Square Feet': '250 ft²',
								'Cubic Feet': '2,000 ft³',
								'Best For': {
									type: 'checklist',
									list: ['3-Bedroom Apartment'],
								},
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByTwentyUnit,
									heading: '10x30',
								},
								'Square Feet': '300 ft²',
								'Cubic Feet': '2,400 ft³',
								'Best For': {
									type: 'checklist',
									list: ['4-Bedroom House'],
								},
							},
						],
					},
				},
			],
		},
		{
			title: 'Storing Oversized Items',
			modules: [
				{
					type: 'sectionHeader',
					props: {
						slug: 'Storage Oversize items',
						id: 'Storage Oversize items',
						title: 'Storing Oversized Items',
						additionalProps: {
							heading: {
								family: 'rounded',
							},
							paragraph: {
								size: 'tall',
							},
						},
						// showReadmore: true,
						content: {
							image: overSized,
							header: 'Storing Oversize items',
							alt: 'Storing Oversize items',
							additionalProps: {},
							description: [
								'Storing oversized items can be challenging due to their size and shape. These items can quickly fill up smaller units, often requiring space that accommodates both their dimensions and specific needs, such as keeping appliances upright or protecting furniture.',
								'Use the chart below to find the right unit size for any oversized items you might be looking to put in storage.',
							],
						},
					},
				},
				{
					type: 'sizeChart',
					props: {
						id: 'Storage Oversize items',
						slug: 'storage-oversize-items',
						columnWidths: [5, 1],
						headers: [
							{
								label: 'Oversized Item',
								key: 'Oversized Item',
							},
							{
								label: 'Unit Sizes',
								key: 'Unit Sizes',
							},
						],
						rows: [
							{
								'Oversized Item': {
									type: 'icon',
									icon: Bed,
									heading: 'Mattresses & Beds',
									description:
										'Are you wondering how to store a mattress in a storage unit? Be sure to clean it, use a breathable cover, and keep it flat to maintain its shape. Ideally, your mattress should be stored in a [climate-controlled](https://www.sparefoot.com/climate-controlled-storage.html) unit since extreme temperatures and humidity can damage the material.',
								},
								'Unit Sizes': '10x10',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: Fridge,
									heading: 'Refrigerators & Freezers',
									description:
										'How do you store a refrigerator in a storage unit? Switch the appliance off and keep it upright to avoid damaging internal components. Keeping the fridge doors open is a good idea to avoid bad odors and mold.',
								},
								'Unit Sizes': '5x10',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: Kayak,
									heading: 'Kayaks',
									description:
										'The best storage for kayaks are climate-controlled units, which prevent the material from warping or breaking. To prevent damage, lay the kayaks horizontally on foam padding or wall mounts.',
								},
								'Unit Sizes': '5x15',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: Bike,
									heading: 'Bicycles',
									description:
										'Bikes are best kept stored along the edges of a storage unit. Bikes can often be stored vertically or with the use of wall hooks to save floor space.',
								},
								'Unit Sizes': '5x10',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: Couch,
									heading: 'Couches & Sectionals',
									description:
										'To store a couch in a storage unit, first, clean the couch to remove any dirt or debris. To store a sectional couch, begin by disassembling it if possible, separating the sections to make handling and storage more manageable. Wrap the couch in moving blankets or plastic wrap to protect it from dust and damage. Position the couch in the unit on its side or upright to save space, and ensure it’s away from walls to allow for airflow.',
								},
								'Unit Sizes': '5x10 to 10x15',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: Mower,
									heading: 'Lawn Mowers',
									description:
										'Drain any gas or oil from lawn mowers and other outdoor equipment before storage. These can often fit neatly in the corners or beneath other larger furniture items, maximizing floor space.',
								},
								'Unit Sizes': '5x10 to 10x10',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: TV,
									heading: 'TVs',
									description:
										'Large flat-screen TVs should be stored upright to avoid pressure on the screens, preferably in their original boxes if possible. Make sure they’re covered and placed away from heavy items that could fall on them.',
								},
								'Unit Sizes': '5x10',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: Washer,
									heading: 'Washing Machines & Dryers',
									description:
										'Disconnect and drain washing machines and other appliances before storing them. Use the storage space inside the washing machine or dryer for smaller, lightweight items to maximize your space usage.',
								},
								'Unit Sizes': '5x10',
							},
							{
								'Oversized Item': {
									type: 'icon',
									icon: Table,
									heading: 'Dining Room Tables',
									description:
										'Tables can be disassembled to save space; remove the legs and store them separately. Stack chairs when possible, using protective padding to prevent scratches.',
								},
								'Unit Sizes': '5x10',
							},
						],
					},
				},
			],
		},
		{
			title: 'Vehicle Storage Units',
			modules: [
				{
					type: 'sectionHeader',
					props: {
						slug: 'Storage Oversize items',
						id: 'Storage Oversize items',
						additionalProps: {
							heading: {
								family: 'rounded',
								size: 'large',
								weight: 'ultraBold',
							},
							paragraph: {
								size: 'tall',
								weight: 'standard',
							},
						},
						content: {
							image: VehicleStorage,
							header: 'Vehicle Storage Units',
							alt: 'Vehicle Storage Units',
							mobileOnly: true,
							description: [
								'Vehicle storage sizes range from 20 feet to 50 feet in length. Most cars will generally fit into a 10x20 unit, and most RVs and boats will generally fit into a 35-foot unit. Oversized vehicles or large Class A RVs may need a unit up to 50 feet long.',
								'Vehicle storage units often provide indoor parking spaces or covered outdoor parking to protect against the elements. Some storage facilities offer enclosed vehicle units.',
							],
						},
					},
				},
				{
					type: 'vehicleSearch',
					props: {
						title: '### Search for Vehicle Storage',
						buttonText: 'Find Vehicle Storage',
					},
				},
				{
					type: 'markdownSection',

					props: {
						additionalProps: {
							heading: {
								size: 'medium',
							},
						},
						content: `### What Size Storage Unit Is Needed to Store a Car? [Explore car storage ![Link Arrow Icon](${arrow})](https://www.sparefoot.com/car-storage.html) `,
					},
				},
				{
					type: 'unitCards',
					id: 'vehicle storage unit cards',
					props: {
						slug: 'vehicle-storage-unit-cards',
						scrollFactor: 3,
						unitCards: [
							{
								layout: false,
								plain: true,
								image: vehicle10x15,
								content:
									"#### 10’ Wide x 15’ Long\n - Most compact and two-door cars, like hatchbacks, crossovers, and small SUVs, come in at just around 15 feet in length. \n - Always make sure to measure your car before renting out a storage unit; it must be under 15 feet in length to fit in a 10'x15' unit. \n - Because most cars fit into a 10' wide unit, most car storage facilities will not note the width on their facility page.",
							},
							{
								layout: false,
								plain: true,
								image: vehicle10x20,
								content:
									"#### 10’ Wide x 20’ Long \n - Most cars are less than 20 feet long and will fit comfortably inside a 10'x20' car storage unit. \n - This includes SUVs, crossovers, sedans, minivans, pickup trucks, and most full-sized vans. \n - Because most cars fit into a 10' wide unit, most car storage facilities will not note the width on their facility page.",
							},
							{
								layout: false,
								plain: true,
								image: vehicle10x25,
								content:
									'#### 10’ Wide x 25’ Long \n - Perfect for larger vehicles or a boat. \n - Small Class B campers, small Class C campers, travel trailers, toy trailers, and pop-ups may also fit in spaces designed for RV storage.',
							},
							{
								layout: false,
								plain: true,
								image: vehicle10x30,
								content:
									"#### 10’ Wide x 30’ Long\n - Very few vehicle models require a 10'x30' storage unit, except for the largest trucks and vans. \n - Storage units typically have an 8' to 10' tall ceiling, so if your truck is on larger wheels or on a lift kit, it may be too tall for some units. Always be sure to measure the height of larger cars. \n - Because most cars fit into a 10' wide unit, most car storage facilities will not note the width on their facility page.",
							},
							{
								layout: false,
								plain: true,
								image: vehicle10x35,
								content:
									'#### 10’ Wide x 35’ Long \n - Store one or multiple vehicles with plenty of other possessions, including furniture and large appliances. \n - This size can typically contain large Class B and Class C campers, mid-to-large-sized travel trailers, small-to-mid-sized fifth-wheel campers, large toy trailers, and small Class A campers.',
							},
							{
								layout: false,
								plain: true,
								image: vehicle10x40,
								content:
									"#### 10’ Wide x 40’ Long \n - The largest of RVs will fit into a 40' storage space. This includes most Class A campers, large travel trailers, and fifth-wheel trailers. \n - Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet.",
							},
							{
								layout: false,
								plain: true,
								image: vehicle10x50,
								content:
									"#### 10’ Wide x 50’ Long \n- 50' RV storage space will handle the largest of RVs, like large Class A campers, travel trailers, and destination trailers. \n - Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet.",
							},
						],
					},
				},
				{
					type: 'markdownSection',
					props: {
						additionalProps: {
							heading: {
								size: 'medium',
							},
						},
						content:
							'### What Size Storage Unit Is Needed to Store an RV or Boat?',
					},
				},
				{
					type: 'unitCards',
					id: 'rv and boat unit cards',
					props: {
						slug: 'rv-and-boat-unit-cards',
						scrollable: false,
						unitCards: [
							{
								layout: false,
								plain: true,
								image: boatIcon,
								content: `#### 35' Long Units \n Most RVs and boats will fit into a 35-foot long unit.  \n  \n [Dive into boat storage ![Link Arrow Icon](${arrow})](https://www.sparefoot.com/boat-storage.html)`,
							},
							{
								layout: false,
								plain: true,
								image: vehicle10x50,
								content: `#### 50' Long Units \n Most oversized vehicles and RVs will fit into a unit that’s up 50-foot long.   \n  \n [Uncover RV storage tips ![Link Arrow Icon](${arrow})](https://www.sparefoot.com/rv-storage.html)`,
							},
						],
					},
				},
			],
		},
		{
			title: 'Storage Unit Size FAQs',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Storage Unit Size FAQs',
						id: 'Storage Unit Size FAQs',
						faqs: [
							{
								question: 'How tall are storage units?',
								answer: 'The typical height of a storage unit is 8 feet. However, depending on the facility and type of storage, some units may be taller or shorter. [Read more about different self-storage solutions](https://www.sparefoot.com/storage-101.html) and [explore how self-storage works](https://storageguide.sparefoot.com/the-basics/).',
							},
							{
								question:
									'What is the most popular storage unit size?',
								answer: 'A 10x10 unit is the most popular storage unit size. Think of it as the size of an extra bedroom since most bedrooms are about 10x12.',
							},
							{
								question:
									'What size storage unit do I need to store a few boxes?',
								answer: 'If you need to store only a few boxes for seasonal items, sporting equipment, or business inventory, your best option is to rent a storage locker or a 5x5 unit.',
							},
							{
								question:
									'What size storage unit do I need for a 1-bedroom apartment?',
								answer: 'Depending on your furniture, a 5x15 or a 10x10 storage unit typically holds the contents of a one-bedroom apartment. A mattress set, dressers, nightstands, small sofa, chairs, TV, coffee table, bookshelves, and several boxes would fit in either unit size.',
							},
							{
								question:
									'What size storage unit do I need for a 2-bedroom apartment?',
								answer: 'Most choose either a 10x10 or a 10x15 unit for a two-bedroom apartment. A 10x10 unit is the most common rented storage unit size and can hold the contents of two bedrooms and an entire family room. A 10x15 unit can fit items from up to three bedrooms and larger items (TVs, pianos, or appliances).',
							},
							{
								question:
									'What size storage unit do I need for a 3-bedroom house?',
								answer: 'A 10x20 or a 10x30 storage unit are both the perfect size for storing furniture items and boxes from a 3-bedroom house. You can fit multiple mattress sets, couches, major appliances, a dining room set, outdoor equipment, and more.',
							},
							{
								question:
									'What size storage unit do I need for a 4-bedroom house?',
								answer: 'A 10x30 unit is typically the largest in most self-storage facilities and perfect for a 4-bedroom house. You can store almost anything you need, from mattress sets to living room furniture, dining room sets, appliances, patio furniture, and even vehicles or boats.* \n \n&ensp; \n \n *_Does not apply to all units. Check that your storage facility allows vehicle storage._',
							},
							{
								question:
									'What size moving truck should I get for a 10x10 storage unit?',
								answer: 'We recommend reserving at least a 15-foot moving truck to hold the furniture items you need to store in a 10x10 unit.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Featured Cities',
			modules: [
				{
					type: 'citiesSection',
					id: 'psp-cities',
					props: {
						title: 'Find Storage Near You',
						image: findStorageNearYouPin,
						className: 'size-guide-cities',
						cities: [
							{
								name: 'Albuquerque, NM',
								url: '/Albuquerque-NM-self-storage.html',
							},
							{
								name: 'Atlanta, GA',
								url: '/Atlanta-GA-self-storage.html',
							},
							{
								name: 'Austin, TX',
								url: '/Austin-TX-self-storage.html',
							},
							{
								name: 'Boston, MA',
								url: '/Boston-MA-self-storage.html',
							},
							{
								name: 'Bronx, NY',
								url: '/Bronx-NY-self-storage.html',
							},
							{
								name: 'Brooklyn, NY',
								url: '/Brooklyn-NY-self-storage.html',
							},
							{
								name: 'Charlotte, NC',
								url: '/Charlotte-NC-self-storage.html',
							},
							{
								name: 'Chicago, IL',
								url: '/Chicago-IL-self-storage.html',
							},
							{
								name: 'Cincinnati, OH',
								url: '/Cincinnati-OH-self-storage.html',
							},
							{
								name: 'Colorado, Springs',
								url: '/Colorado-Springs-CO-self-storage.html',
							},
							{
								name: 'Columbus, OH',
								url: '/Columbus-OH-self-storage.html',
							},
							{
								name: 'Dallas, TX',
								url: '/Dallas-TX-self-storage.html',
							},
							{
								name: 'Denver, CO',
								url: '/Denver-CO-self-storage.html',
							},
							{
								name: 'Detroit, MI',
								url: '/Detroit-MI-self-storage.html',
							},
							{
								name: 'Fort, Myers',
								url: '/Fort-Myers-FL-self-storage.html',
							},
							{
								name: 'Fort, Worth',
								url: '/Fort-Worth-TX-self-storage.html',
							},
							{
								name: 'Houston, TX',
								url: '/Houston-TX-self-storage.html',
							},
							{
								name: 'Indianapolis, IN',
								url: '/Indianapolis-IN-self-storage.html',
							},
							{
								name: 'Jacksonville, FL',
								url: '/Jacksonville-FL-self-storage.html',
							},
							{
								name: 'Jersey, City',
								url: '/Jersey-City-NJ-self-storage.html',
							},
							{
								name: 'Kansas, City',
								url: '/Kansas-City-MO-self-storage.html',
							},
							{
								name: 'Las, Vegas',
								url: '/Las-Vegas-NV-self-storage.html',
							},
							{
								name: 'Long, Beach',
								url: '/Long-Beach-CA-self-storage.html',
							},
							{
								name: 'Los, Angeles',
								url: '/Los-Angeles-CA-self-storage.html',
							},
							{
								name: 'Manhattan, NY',
								url: '/Manhattan-NY-self-storage.html',
							},
							{
								name: 'Mesa, AZ',
								url: '/Mesa-AZ-self-storage.html',
							},
							{
								name: 'Miami, FL',
								url: '/Miami-FL-self-storage.html',
							},
							{
								name: 'Minneapolis, MN',
								url: '/Minneapolis-MN-self-storage.html',
							},
							{
								name: 'Nashville, TN',
								url: '/Nashville-TN-self-storage.html',
							},
							{
								name: 'New, York',
								url: '/New-York-NY-self-storage.html',
							},
							{
								name: 'Oklahoma, City',
								url: '/Oklahoma-City-OK-self-storage.html',
							},
							{
								name: 'Orlando, FL',
								url: '/Orlando-FL-self-storage.html',
							},
							{
								name: 'Philadelphia, PA',
								url: '/Philadelphia-PA-self-storage.html',
							},
							{
								name: 'Phoenix, AZ',
								url: '/Phoenix-AZ-self-storage.html',
							},
							{
								name: 'Pittsburgh, PA',
								url: '/Pittsburgh-PA-self-storage.html',
							},
							{
								name: 'Portland, OR',
								url: '/Portland-OR-self-storage.html',
							},
							{
								name: 'Queens, NY',
								url: '/Queens-NY-self-storage.html',
							},
							{
								name: 'Raleigh, NC',
								url: '/Raleigh-NC-self-storage.html',
							},
							{
								name: 'Sacramento, CA',
								url: '/Sacramento-CA-self-storage.html',
							},
							{
								name: 'San, Antonio',
								url: '/San-Antonio-TX-self-storage.html',
							},
							{
								name: 'San, Diego',
								url: '/San-Diego-CA-self-storage.html',
							},
							{
								name: 'San, Francisco',
								url: '/San-Francisco-CA-self-storage.html',
							},
							{
								name: 'San, Jose',
								url: '/San-Jose-CA-self-storage.html',
							},
							{
								name: 'Seattle, WA',
								url: '/Seattle-WA-self-storage.html',
							},
							{
								name: 'St, Petersburg',
								url: '/St-Petersburg-FL-self-storage.html',
							},
							{
								name: 'St., Louis',
								url: '/St.-Louis-MO-self-storage.html',
							},
							{
								name: 'Tampa, FL',
								url: '/Tampa-FL-self-storage.html',
							},
							{
								name: 'Tucson, AZ',
								url: '/Tucson-AZ-self-storage.html',
							},
							{
								name: 'Virginia, Beach',
								url: '/Virginia-Beach-VA-self-storage.html',
							},
							{
								name: 'Washington, DC',
								url: '/Washington-DC-self-storage.html',
							},
						],
					},
				},
			],
		},
	],
};
